<template>
    <v-dialog v-model="shutdownDialog" max-width="350" persistent>
        <v-card height="300">
            <v-card-text>
                <v-row class="d-flex">
                    <v-col align="center" cols="12" class="mt-5">
                        {{ shutdownMessage }}
                    </v-col>
                    <v-col align="center" class="mt-5">
                        <v-progress-circular :size="150" indeterminate color="secondary"></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "ShutdownDialog",
    data() {
        return {
            shutdownDialog: false,
            shutdownMessage: ""
        }
    },
    watch: {
        "$store.state.NotificationStore.shutdown"(val) {
            this.shutdownDialog = !!val;
            this.shutdownMessage = val.message;
            console.log("Shutdown", val);
        }
    }
}
</script>